<template>
    <div class="step-eight">

        <!-- Выбор метода: карточки с иконками -->
        <div class="method-cards">
            <div
                class="method-card"
                :class="{ 'method-card--active': uploadMethod === 'uploadByDevice' }"
                @click="uploadMethod = 'uploadByDevice'"
            >
                <div class="method-card__icon-wrap">
                    <i class="fas fa-folder-open"></i>
                </div>
              <div class="method-card__content">
                <div class="method-card__title">Устройство</div>
                <div class="method-card__sub">Выбрать файлы</div>
              </div>
              <div v-if="uploadMethod === 'uploadByDevice'" class="method-card__check">
                    <i class="fas fa-check-circle"></i>
                </div>
            </div>

          <!-- Старый блок Telegram временно отключён
          <div
              class="method-card"
              :class="{ 'method-card--active': uploadMethod === 'uploadByTelegram' }"
              @click="uploadMethod = 'uploadByTelegram'"
          >
              <div class="method-card__icon-wrap method-card__icon-wrap--tg">
                  <i class="fab fa-telegram-plane"></i>
              </div>
              <div class="method-card__content">
                <div class="method-card__title">Telegram</div>
                <div class="method-card__sub">Старый способ</div>
              </div>
              <div v-if="uploadMethod === 'uploadByTelegram'" class="method-card__check">
                  <i class="fas fa-check-circle"></i>
              </div>
          </div>-->
          <div class="method-card method-card--disabled">
            <div class="method-card__icon-wrap method-card__icon-wrap--tg">
              <i class="fab fa-telegram-plane"></i>
            </div>
            <div class="method-card__content">
              <div class="method-card__title">Telegram</div>
              <div class="method-card__sub">Старый способ временно недоступен</div>
            </div>
          </div>
        </div>

        <!-- Блок для загрузки с устройства -->
        <transition name="fade">
            <div v-if="uploadMethod === 'uploadByDevice'">
                <ReusableReportPhotos />
                <div v-if="totalPhotoCount" class="mb-3 text-muted" role="status">
                    В отчёте: {{ totalPhotoCount }} · ранее загружено {{ reusedPhotos.length }} · новых {{ photos.length }}
                </div>

                <!-- Переиспользуемый компонент загрузки с устройства -->
                <PhotoUploadDevice
                    :key="photoUploadResetVersion"
                    v-if="!photosNotAvailable"
                    v-model="photos"
                    @status-change="onUploadStatusChange"
                    @all-files-unavailable="onAllFilesUnavailable"
                />

                <!-- Чекбокс "фото отсутствуют" -->
                <b-form-checkbox
                    v-if="!totalPhotoCount"
                    v-model="photosNotAvailable"
                    :value="true"
                    :unchecked-value="false"
                    class="mt-3 text-center"
                >
                    <span class="text-muted">Фотографии по смене отсутствуют</span>
                </b-form-checkbox>

                <!-- Причина отсутствия -->
                <div v-if="photosNotAvailable" class="mt-3">
                    <ReportExplanationField v-if="textQualityEnabled" kind="photo" :reason-key.sync="photoReasonKey" :detail.sync="emptyPhotoComment" />
                    <label v-if="!textQualityEnabled" class="form-label text-muted mb-1">
                        <i class="fas fa-comment-alt"></i> Причина отсутствия фотографий
                    </label>
                    <AppTextarea v-if="!textQualityEnabled"
                        v-model="emptyPhotoComment"
                        placeholder="Введите примечание..."
                        class="step-eight__detail"
                        size="sm"
                    ></AppTextarea>
                </div>

            </div>
        </transition>

        <!-- Блок Telegram -->
        <transition name="fade">
            <div v-if="uploadMethod === 'uploadByTelegram'" class="telegram-info mt-3">
                <div class="telegram-info__icon">
                    <i class="fab fa-telegram-plane"></i>
                </div>
                <p class="telegram-info__text">
                    Загрузка фотографий будет выполнена через чат Telegram
                </p>
                <small class="text-muted">
                    После отправки отчёта вы будете перенаправлены в чат для загрузки фото
                </small>
                <ReportExplanationField v-if="textQualityEnabled" kind="photo" :reason-key.sync="photoReasonKey" :detail.sync="emptyPhotoComment" />
            </div>
        </transition>

        <ReportExplanationStatisticsPanel v-if="textQualityEnabled" kind="photo"
            :reason-key="photosNotAvailable || uploadMethod === 'uploadByTelegram' ? photoReasonKey : ''" />

        <!-- Fallback-модалка: все файлы не удалось прочитать -->
        <b-modal
            v-model="showTelegramFallbackModal"
            title="Не удалось подготовить файлы"
            ok-title="Перейти к способу Telegram"
            cancel-title="Закрыть"
            @ok="switchToTelegramAndClose"
            @cancel="showTelegramFallbackModal = false"
            @hide="showTelegramFallbackModal = false"
        >
            <p class="mb-0">
                Выбранные файлы не удалось прочитать с устройства. Рекомендуем отправить отчёт и загрузить фотографии через Telegram (старый способ).
            </p>
        </b-modal>

    </div>
</template>

<script>
import PhotoUploadDevice from '@/components/PhotoUploadDevice/PhotoUploadDevice.vue';
import ReusableReportPhotos from '../ReusableReportPhotos.vue';
import ReportExplanationField from '../ReportExplanationField.vue';
import ReportExplanationStatisticsPanel from '../ReportExplanationStatisticsPanel.vue';
import explanations from '../../../../../shared/reportExplanations';

export default {
    name: 'StepEight',
    components: {
        ReusableReportPhotos,
        ReportExplanationField,
        ReportExplanationStatisticsPanel,
        PhotoUploadDevice
    },
    data() {
        return {
            showTelegramFallbackModal: false,
            allFilesProcessedForDevice: false
        };
    },
    computed: {
        reusedPhotos() { return this.$store.state.shiftReport.reusedPhotos || []; },
        totalPhotoCount() { return this.photos.length + this.reusedPhotos.length; },
        textQualityEnabled() { return this.$store.state.shiftReport.textQualityEnabled; },
        photoReasonKey: {
            get() { return this.$store.state.shiftReport.photoReasonKey; },
            set(value) { this.$store.commit('shiftReport_setPhotoReasonKey', value); this.$store.dispatch('shiftReport_updateCache'); }
        },
        photos: {
            get() {
                return this.$store.state.shiftReport.photos;
            },
            set(files) {
                const value = Array.isArray(files) ? files : [];
                this.$store.commit('shiftReport_setPhotos', value);
            }
        },
        uploadMethod: {
            get() {
                return this.$store.state.shiftReport.uploadMethod;
            },
            set(v) {
                this.$store.commit('shiftReport_setUploadMethod', v);
            }
        },
        photosNotAvailable: {
            get() {
                return this.$store.state.shiftReport.photosNotAvailable;
            },
            set(v) {
                this.$store.commit('shiftReport_setPhotosNotAvailable', v);
                this.$store.dispatch('shiftReport_updateCache');
            }
        },
        emptyPhotoComment: {
            get() {
                return this.$store.state.shiftReport.emptyPhotoComment;
            },
            set(v) {
                this.$store.commit('shiftReport_setEmptyPhotoComment', v);
                this.$store.dispatch('shiftReport_updateCache');
            }
        },
        isTelegramWebApp() {
            return this.$store.getters.isTelegramWebApps;
        },
        photoUploadResetVersion() {
            return this.$store.state.lifecycle && this.$store.state.lifecycle.photoUploadResetVersion
                ? this.$store.state.lifecycle.photoUploadResetVersion
                : 0;
        }
    },
    methods: {
        isCanContinue() {
            const { photosNotAvailable, emptyPhotoComment, photos, uploadMethod, allFilesProcessedForDevice } = this;
            if (uploadMethod === 'uploadByDevice') {
                if (photosNotAvailable) {
                    if (this.textQualityEnabled) return !explanations.validateExplanation('photo', this.photoReasonKey, emptyPhotoComment);
                    return emptyPhotoComment && !!emptyPhotoComment.length;
                }
                return allFilesProcessedForDevice && this.totalPhotoCount > 0;
            }
            return !this.textQualityEnabled || !explanations.validateExplanation('photo', this.photoReasonKey, emptyPhotoComment);
        },
        onAllFilesUnavailable() {
            this.showTelegramFallbackModal = true;
        },
        onUploadStatusChange(payload) {
            this.allFilesProcessedForDevice = !!(payload && (payload.allProcessed || payload.total === 0));
            this.$emit('can-continue', { value: this.isCanContinue() });
        },
        switchToTelegramAndClose() {
            this.uploadMethod = 'uploadByTelegram';
            this.showTelegramFallbackModal = false;
        }
    },
    watch: {
        reusedPhotos() { this.$emit('can-continue', {value: this.isCanContinue()}); },
        photoReasonKey() { this.$emit('can-continue', {value: this.isCanContinue()}); },
        textQualityEnabled() { this.$emit('can-continue', {value: this.isCanContinue()}); },
        photos: {
            immediate: true,
            handler() {
                this.$emit('can-continue', { value: this.isCanContinue() });
            }
        },
        photosNotAvailable() {
            this.$emit('can-continue', { value: this.isCanContinue() });
        },
        emptyPhotoComment() {
            this.$emit('can-continue', { value: this.isCanContinue() });
        },
        uploadMethod() {
            this.$store.commit('shiftReport_setReusedPhotos', []);
            // Очищаем выбранные файлы и сбрасываем прогресс при смене способа загрузки
            this.$store.commit('shiftReport_setPhotos', []);
            this.$store.commit('shiftReport_setPhotosNotAvailable', false);
            this.$store.commit('shiftReport_setEmptyPhotoComment', null);
            this.$store.commit('shiftReport_setUploadProgress', { done: 0, total: 0 });
            this.$emit('can-continue', { value: this.isCanContinue() });
        }
    }
};
</script>

<style lang="scss" scoped>
// Переменные (совместимы с Bootstrap 4 проекта)
$primary:      #007bff;
$primary-light: #e8f0fe;
$border-color: #dee2e6;
$border-radius: 12px;
$transition:   0.2s ease;
$text-muted:   #6c757d;

// ───────────────────────────────────────────────
// Корневой контейнер
// ───────────────────────────────────────────────
.step-eight {
    width: 100%;
    min-width: 0;
    max-width: 640px;
    margin: 0 auto;
    padding: 0 4px;
}
.step-eight__detail { resize: vertical; overflow-y: auto; }

// ───────────────────────────────────────────────
// Карточки выбора метода
// ───────────────────────────────────────────────
.method-cards {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;

    @media (max-width: 480px) {
        flex-direction: column;
    }
}

.method-card {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 12px 16px;
    border: 2px solid $border-color;
    border-radius: $border-radius;
    background: #fff;
    cursor: pointer;
    transition: border-color $transition, box-shadow $transition, background $transition;
    user-select: none;
    text-align: center;

    &:hover {
        border-color: lighten($primary, 20%);
        box-shadow: 0 2px 12px rgba($primary, 0.12);
    }

    &--active {
        border-color: $primary;
        background: $primary-light;
        box-shadow: 0 4px 16px rgba($primary, 0.18);
    }

    &__icon-wrap {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background: rgba($primary, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        font-size: 22px;
        color: $primary;
        transition: background $transition;

        &--tg {
            background: rgba(#29B6F6, 0.12);
            color: #0088CC;
        }
    }

    &--active &__icon-wrap {
        background: rgba($primary, 0.18);
    }

    &__title {
        font-weight: 600;
        font-size: 15px;
        color: #2c3e50;
        margin-bottom: 3px;
    }

    &__sub {
        font-size: 12px;
        color: $text-muted;
    }

    &__check {
        position: absolute;
        top: 8px;
        right: 10px;
        font-size: 16px;
        color: $primary;
        line-height: 1;
    }

    @media (max-width: 480px) {
        flex-direction: row;
        justify-content: flex-start;
        padding: 14px 16px;
        text-align: left;

        &__icon-wrap {
            width: 40px;
            height: 40px;
            min-width: 40px;
            font-size: 18px;
            margin-bottom: 0;
            margin-right: 14px;
        }

        &__check {
            top: 50%;
            transform: translateY(-50%);
        }
    }

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      background: #f8f9fa;

      &:hover {
        border-color: $border-color;
        box-shadow: none;
      }
    }
}

// ───────────────────────────────────────────────
// Drop-зона
// ───────────────────────────────────────────────
.dropzone {
    border: 2px dashed $border-color;
    border-radius: $border-radius;
    padding: 36px 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color $transition, background $transition;
    background: #fafbfc;

    &:hover {
        border-color: lighten($primary, 20%);
        background: lighten($primary-light, 4%);
    }

    &--active {
        border-color: $primary;
        background: $primary-light;

        .dropzone__icon {
            color: $primary;
            transform: scale(1.15);
        }
    }

    &__icon {
        font-size: 40px;
        color: #adb5bd;
        margin-bottom: 12px;
        display: block;
        transition: color $transition, transform $transition;
    }

    &__text {
        font-size: 15px;
        font-weight: 500;
        color: #495057;
        margin-bottom: 6px;
    }

    &__hint {
        font-size: 12px;
        color: $text-muted;
        margin: 0;

        i {
            margin-right: 2px;
        }
    }

    @media (max-width: 576px) {
        padding: 24px 16px;

        &__icon {
            font-size: 32px;
        }

        &__text {
            font-size: 14px;
        }
    }
}

// ───────────────────────────────────────────────
// Шапка над сеткой
// ───────────────────────────────────────────────
.files-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__count {
        font-size: 13px;
        font-weight: 600;
        color: #495057;

        i {
            color: $primary;
            margin-right: 4px;
        }
    }
}

// ───────────────────────────────────────────────
// Ограниченный по высоте контейнер превью
// ───────────────────────────────────────────────
.photo-grid-wrapper {
    max-height: 340px;
    overflow-y: auto;
    padding-right: 2px;
    -webkit-overflow-scrolling: touch;
}

// ───────────────────────────────────────────────
// CSS Grid превью
// ───────────────────────────────────────────────
.photo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;

    @media (max-width: 400px) {
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
        gap: 8px;
    }
}

.photo-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background: #f1f3f5;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

    &__preview {
        position: relative;
    }

    &__spinner {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.6);
        z-index: 1;

        i {
            font-size: 18px;
            color: #6c757d;
        }
    }

    &__img {
        width: 100%;
        aspect-ratio: 1;
        object-fit: cover;
        display: block;
    }

    &__icon-preview {
        width: 100%;
        aspect-ratio: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f1f3f5, #e9ecef);
        color: #495057;
    }

    &__icon {
        font-size: 26px;
        margin-bottom: 4px;
        color: #6c757d;
    }

    &__format {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #495057;
    }

    &__delete {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        border: none;
        cursor: pointer;
        font-size: 11px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        transition: background $transition;

        &:hover {
            background: rgba(220, 53, 69, 0.9);
        }
    }

    &__name {
        font-size: 10px;
        color: $text-muted;
        padding: 3px 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: #fff;
        line-height: 1.4;
    }
}

// ───────────────────────────────────────────────
// Telegram info-блок
// ───────────────────────────────────────────────
.telegram-info {
    text-align: center;
    padding: 32px 20px;
    border: 1px solid #e9ecef;
    border-radius: $border-radius;
    background: #f8f9fa;

    &__icon {
        font-size: 40px;
        color: #0088CC;
        margin-bottom: 12px;
    }

    &__text {
        font-size: 15px;
        font-weight: 500;
        color: #495057;
        margin-bottom: 6px;
    }
}

// ───────────────────────────────────────────────
// Transition fade
// ───────────────────────────────────────────────
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
